import { Box, Button as MuiButton, Grid, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { rippleStyles } from '@ncr-retail/base-retail-components';
import React from 'react';
import { keypadHeaderStyles } from './keypad-header-styles';

const KeypadHeader: React.FC<IKeypadHeaderProps> = ({
  topLabelText,
  handleClose,
  keypadTestIdPrefix,
  isSingleLine,
}): JSX.Element | null => {
  const classes = keypadHeaderStyles();
  const ripple = rippleStyles();
  if (!topLabelText) {
    return null;
  }
  return (
    <Grid item container>
      <Grid container className={classes.labelContainer} justifyContent='space-between'>
        <Grid wrap='nowrap' justifyContent='space-between' item container>
          <Typography
            variant='subtitle1'
            className={`${classes.defaultLabel} ${isSingleLine ? classes.singleLineLabel : ''}`}
            dangerouslySetInnerHTML={{ __html: topLabelText.replace(/\n/g, '<br /><br />') }}
            data-testid='keypad-header-text'
          />
          {handleClose && (
            <Box>
              <MuiButton
                className={`${classes.keypadButton} ${ripple.containedButton}`}
                onClick={() => {
                  handleClose();
                }}
                data-testid={
                  keypadTestIdPrefix
                    ? `${keypadTestIdPrefix}keypad-close-button`
                    : 'keypad-close-button'
                }
              >
                <CloseIcon className={classes.closeIcon} />
              </MuiButton>
            </Box>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

interface IKeypadHeaderProps {
  topLabelText?: string;
  keypadTestIdPrefix: string | undefined;
  handleClose?: () => void;
  isSingleLine?: boolean;
}

export default KeypadHeader;
